module.exports = __webpack_public_path__ + "img/figma-link.d8b23082.svg";